import React from 'react';

const Accordion = ({ title, children, index }) => {
  return (
    <div className="accordion-wrapper">
      <button className="accordion flex space">
        <div className="flex centered">
          <span className="dot"></span>
          <span>{index}</span>
          <h3>{title}</h3>
        </div>
        <h6>+</h6>
      </button>
      <div className="panel">
        {children}
      </div>
    </div>
  );
};

export default Accordion;
